import { BrowserRouter as Router } from "react-router-dom";
import { ThemeProvider } from "@mui/material";
import { Provider } from "react-redux";
import { lazy, Suspense } from "react";

import { theme } from "./theme";
import { legacy_createStore } from "redux";
import "./index.css";
import "./styles.scss";
import rootReducer from "redux/reducers";
import FreshdiLoading from "./Components/loading/FreshdiLoading";
import useFacebookPixel from "hooks/useFacebookPixel";

// Lazy load AppProvider and AppRouter
const AppProvider = lazy(() => import("providers/app"));
const AppRouter = lazy(() => import("./router"));

const store = legacy_createStore(rootReducer);

// Initialize analytics only on client side
if (typeof window !== "undefined") {
  import("./utils/analytics").then(({ initGA }) => initGA());
}

export default function App() {
  useFacebookPixel();

  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <Router>
          <Suspense fallback={<FreshdiLoading />}>
            <AppProvider>
              <Suspense fallback={<FreshdiLoading />}>
                <AppRouter />
              </Suspense>
            </AppProvider>
          </Suspense>
        </Router>
      </ThemeProvider>
    </Provider>
  );
}
